// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/ploni-regular-aaa.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/ploni-light-aaa.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/ploni-bold-aaa.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/Rubik-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/Rubik-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/Rubik-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'PloniRegular';
	src: local('PloniRegular'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
	font-family: 'PloniLight';
	src: local('PloniLight'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
	font-family: 'PloniBold';
	src: local('PloniBold'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
	font-family: 'RubikRegular';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
	font-family: 'RubikLight';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
	font-family: 'RubikMedium';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
@font-face {
	font-family: 'RubikSemiBold';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}
.grecaptcha-badge {
	visibility: hidden !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme/fonts.css"],"names":[],"mappings":"AAAA;CACC,2BAA2B;CAC3B,sFAA0F;AAC3F;;AAEA;CACC,yBAAyB;CACzB,oFAAsF;AACvF;;AAEA;CACC,wBAAwB;CACxB,mFAAoF;AACrF;;AAEA;CACC,2BAA2B;CAC3B,+DAA6D;AAC9D;AACA;CACC,yBAAyB;CACzB,+DAA2D;AAC5D;AACA;CACC,0BAA0B;CAC1B,+DAA4D;AAC7D;AACA;CACC,4BAA4B;CAC5B,+DAA8D;AAC/D;AACA;CACC,6BAA6B;AAC9B","sourcesContent":["@font-face {\n\tfont-family: 'PloniRegular';\n\tsrc: local('PloniRegular'), url('assets/fonts/ploni-regular-aaa.woff2') format('truetype');\n}\n\n@font-face {\n\tfont-family: 'PloniLight';\n\tsrc: local('PloniLight'), url('assets/fonts/ploni-light-aaa.woff2') format('truetype');\n}\n\n@font-face {\n\tfont-family: 'PloniBold';\n\tsrc: local('PloniBold'), url('assets/fonts/ploni-bold-aaa.woff2') format('truetype');\n}\n\n@font-face {\n\tfont-family: 'RubikRegular';\n\tsrc: url('assets/fonts/Rubik-Regular.ttf') format('truetype');\n}\n@font-face {\n\tfont-family: 'RubikLight';\n\tsrc: url('assets/fonts/Rubik-Light.ttf') format('truetype');\n}\n@font-face {\n\tfont-family: 'RubikMedium';\n\tsrc: url('assets/fonts/Rubik-Medium.ttf') format('truetype');\n}\n@font-face {\n\tfont-family: 'RubikSemiBold';\n\tsrc: url('assets/fonts/Rubik-SemiBold.ttf') format('truetype');\n}\n.grecaptcha-badge {\n\tvisibility: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
